const fileDownloadButtonFormService = {
  title: 'Gerar Relatório'
};

export default fileDownloadButtonFormService;
